<template>
    <div class="activity-description">
        <LazyImage
            class="activity-description-image"
            v-if="product.ImageUrl"
            :src="product.ImageUrl"
            :alt="product.Description" />
        <div class="activity-description-content">
            <div>
                <div class="activity-description-content-description">
                    {{ product.Description }}
                </div>
                <div class="activity-description-content-dates">
                    <div v-if="date">
                        {{ date }}
                    </div>
                </div>
                <div class="activity-description-content-rating">
                    <Rating :rating="product.Rating" />
                </div>
            </div>

            <CancellationPanel :product="product" />
        </div>
        <Divider color="lightGrey" bottomMargin="xxl" topMargin="xxl" thickness="1" />
        <Tickets :product="product" />
    </div>
</template>
<script lang="ts">
    import { computed, defineComponent, PropType } from 'vue';
    import { ActivityProduct } from '@/api/Cart/cart.interfaces';
    import { t } from '@shared/helpers/translation';
    import { getLocaleWeekdayLongMonthYear } from '@shared/helpers/datetime/datetime.formatters';
    import {
        getCartProductCancellation,
        getFirstAmountCartPolicy,
    } from '@/components/shared/Cancellation/CartCancellation/CartCancellation.helpers';
    import LazyImage from '@ui/components/LazyImage/LazyImage.vue';
    import Rating from '@ui/components/Rating/Rating.vue';
    import Tickets from './Tickets/Tickets.vue';
    import Divider from '@ui/components/Divider/Divider.vue';
    import CancellationPanel from '@/components/checkoutPageV3/Shared/CancellationPanel/CancellationPanel.vue';

    export default defineComponent({
        name: 'ActivityModalDetails',
        components: {
            Divider,
            CancellationPanel,
            Rating,
            LazyImage,
            Tickets,
        },
        methods: { t, getLocaleWeekdayLongMonthYear },
        props: {
            product: {
                type: Object as PropType<ActivityProduct>,
                required: true,
            },
        },
        setup({ product }) {
            const productCancellation = getCartProductCancellation(product);

            const isRefundable = productCancellation.Refundable;

            const freeCancellationUntil =
                getFirstAmountCartPolicy(productCancellation)?.EndDate;

            const date = computed(() =>
                getLocaleWeekdayLongMonthYear(new Date(product.Date))
            );

            return {
                date,
                isRefundable,
                freeCancellationUntil,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'Details';
</style>
